<app-promotion *ngIf="promotion" [promotion]="promotion"></app-promotion>
<app-alert-error [error]="error" [routeToHomepage]="true" [showAppLogo]="true"></app-alert-error>
<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>

